import { Dispatch, SetStateAction, useState } from "react";
import { VendedorInfo } from "../../../EmpresaComponents/EditarDealForm";
import { AddVendedorForm } from "../../../EmpresaComponents/CreateForm/AddVendedorForm";
import { CurrentComponent } from "./DealInformation";
import { SaveButton } from "../../../UtilitiesComponents/SaveButton";
import { CancelButton } from "../../../UtilitiesComponents/CancelButton";
import { useGetVisitaByIdQuery } from "../../../../api/visitasApi";
import { CircularProgress } from "@mui/joy";
import { ErrorMessage } from "../../../UtilitiesComponents/ErrorMessage";
import { IntencionesVendidas } from "./IntencionesVendidas";

interface Props {
    visitaId: number;
    setCurrentComponent: Dispatch<SetStateAction<CurrentComponent>>;
}

export function VisitaDetails({ visitaId, setCurrentComponent }: Props) {
    const [vendedoresAgregados, setVendedoresAgregados] = useState<VendedorInfo[]>([])

    const { data: visita, isFetching, isError, isSuccess } = useGetVisitaByIdQuery(visitaId);

    if(isFetching)
        return (
        <div className="flex justify-center items-center w-full h-full">
            <CircularProgress />
        </div>
    );

    if(isError || !isSuccess)
        return (
        <div className="flex justify-center items-center w-full h-full">
            <ErrorMessage customMessage>
                Ocurrió un problema al cargar la informacion. Intente más tarde.
            </ErrorMessage>
        </div>
    );

    return (
        <div className="flex-1 flex flex-col w-full overflow-hidden">

            <p className="font-semibold text-lg pb-2">Información de la visita</p>

            <div className="flex gap-x-3 justify-between">
                <div>
                    <label className="text-sm font-semibold">Fecha {}</label>
                    <input 
                        disabled
                        value={visita?.fecha}
                        className="
                            w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                            font-semibold text-gray-600 text-sm" />
                </div>

                <div>
                    <label className="text-sm font-semibold">Hora de inicio</label>
                    <input
                        value={visita?.horaInicio}
                        disabled
                        className="
                            w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                            font-semibold text-gray-600 text-sm"/>
                </div>

                <div>
                    <label className="text-sm font-semibold">Hora de fin</label>
                    <input
                        value={visita?.horaFin}
                        disabled
                        className="
                            w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                            font-semibold text-gray-600 text-sm"/>

                </div>
            </div>

            <div className="grid grid-cols-1 gap-x-2">

                <div>
                    <label className="text-sm font-semibold">Turno</label>
                    <input
                        value={visita.turno}
                        disabled
                        className="
                            w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                            font-semibold text-gray-600 text-sm" />
                </div>

            </div>

            <div className="flex gap-x-10 py-2">
                <div>
                    <label className="text-sm font-semibold">Estatus de la visita</label>
                    {visita.terminado 
                    ?
                    <div className="border-2 border-red-400 bg-red-100 w-fit px-3 rounded-full">
                        <p className="h-[26px] font-semibold">{visita.terminado ? "Terminada" : "Abierta"}</p>
                    </div>
                    :
                    <div className="border-2 border-green-400 bg-green-100 w-fit px-3 rounded-full">
                        <p className="h-[26px] font-semibold">{visita.terminado ? "Terminada" : "Abierta"}</p>
                    </div>
                    }
                </div>

                <div>
                    <label className="text-sm font-semibold">Total de intenciones vendidas</label>
                    <p
                        className="
                            w-full h-[26px] my-1 px-2  text-center
                            font-semibold text-gray-600 text-sm" >
                        {visita.intencionesVendidas} intenciones
                    </p>
                </div>
            </div>


            {visita.terminado
            ?
            <IntencionesVendidas 
                intenciones={visita.vendedores ?? []} />
            :
            <AddVendedorForm
                setVendedoresAgregados={setVendedoresAgregados}
                vendedoresAgregados={vendedoresAgregados}
                dealId={visitaId}
                empresaId={0}/>
            }

            <div className="flex gap-x-2 justify-center pt-3">
                {!visita.terminado && (
                <SaveButton 
                    text="Terminar visita"
                    onClick={() => setCurrentComponent({ component: "FinishVisita", visitaId: visitaId }) }
                    type="button"/>
                )}

                <CancelButton
                    text="Regresar"
                    onClick={()=> {
                        setCurrentComponent({ component: "Deal", visitaId: null });
                    }} />
            </div>
        </div>
    );
}